module.exports = __webpack_public_path__ + "img/renbao.ec1c5772.png";